import * as types from 'training/actions/types'
import {apiAction} from 'apa/actions';

const ENDPOINT_URL = 'https://apabackend.quixtest.de/api/trainings/';

export const loadTrainingTemplates = () => (dispatch) => {
    dispatch({type: types.LOAD_TRAINING_TEMPLATES})
    return dispatch(apiAction({
            url: ENDPOINT_URL,
            method: 'GET',
            onSuccess: trainingTemplateList => ({
                type: types.LOAD_TRAINING_TEMPLATES_SUCCESS,
                trainingTemplateList: trainingTemplateList
            }),
            onFailure: (errors) => ({
                type: types.LOAD_TRAINING_TEMPLATES_ERROR,
                errors: errors
            })
    }))
}

export const setSearchText = (searchText) => (dispatch) => dispatch({
    type: types.SEARCH_TRAINING_TEMPLATES,
    searchText: searchText
})

export const selectTrainingTemplate = (trainingTemplate) => (dispatch) => {
    dispatch({
        type: types.DESELECT_TRAINING_TEMPLATE,
    })
    dispatch({
        type: types.SELECT_TRAINING_TEMPLATE,
        trainingTemplate: trainingTemplate
    })
}

export const createTrainingTemplate = (trainingTemplate) => (dispatch) => {
    dispatch({type: types.CREATE_TRAINING_TEMPLATE})
    return dispatch(apiAction({
        url: ENDPOINT_URL,
        method: 'POST',
        data: trainingTemplate,
        onSuccess: trainingTemplate => {
            dispatch(loadTrainingTemplates())
            return {
                type: types.CREATE_TRAINING_TEMPLATE_SUCCESS,
                trainingTemplate: trainingTemplate
            }
        },
        onFailure: (errors) => ({
            type: types.CREATE_TRAINING_TEMPLATE_ERROR,
            errors: errors
        })
    }))
}
export const updateTrainingTemplate = (trainingTemplate) => (dispatch) => {
    dispatch({
        type: types.UPDATE_TRAINING_TEMPLATE,
        payload: trainingTemplate
    })
}


export const saveTrainingTemplate = () => (dispatch, getState) => {
    const state = getState()
    const trainingTemplate = state.training.selectedTrainingTemplate;
    dispatch({type: types.SAVE_TRAINING_TEMPLATE})
    return dispatch(apiAction({
        url: `${ENDPOINT_URL}${trainingTemplate.id}/`,
        method: 'PATCH',
        data: trainingTemplate,
        onSuccess: trainingTemplate => {
            return {
                type: types.SAVE_TRAINING_TEMPLATE_SUCCESS,
                trainingTemplate: trainingTemplate
            }
        },
        onFailure: (errors) => ({
            type: types.SAVE_TRAINING_TEMPLATE_ERROR,
            errors: errors
        })
    }))
}

export const deleteTrainingTemplate = (trainingTemplate) => (dispatch) => {
    dispatch({type: types.DELETE_TRAINING_TEMPLATE})
    dispatch(selectTrainingTemplate(null))
    return dispatch(apiAction({
        url: `${ENDPOINT_URL}${trainingTemplate.id}/`,
        method: 'DELETE',
        onSuccess: () => {
            dispatch(loadTrainingTemplates())
            return {
                type: types.DELETE_TRAINING_TEMPLATE_SUCCESS,
            }
        },
        onFailure: (errors) => ({
            type: types.DELETE_TRAINING_TEMPLATE_ERROR,
            errors: errors
        })
    }))
}
